/**
 * Generated bundle index. Do not edit.
 */

export * from './index';

export {ContainersWindowCrossDomainObserver as ɵb} from './lib/observers/cross-window.observer';
export {UrlOverriderPipe as ɵc} from './lib/pipes/url/url-overrider.pipe';
export {CustomElementRendererRef as ɵd} from './lib/renderers/custom-element.renderer';
export {IframeRendererRef as ɵf} from './lib/renderers/iframe.renderer';
export {NgComponentRendererRef as ɵg} from './lib/renderers/ng-component.renderer';
export {ContainersService as ɵa} from './lib/services/containers.service';
export {ElementUrlsOverriderService as ɵe} from './lib/services/urls-overrider.service';